document.addEventListener('DOMContentLoaded', function () {
  const animatedElements = document.querySelectorAll('.why-choose-section .animation');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = entry.target.getAttribute('data-animation-delay') || '0s';
        entry.target.style.animationDelay = delay;
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  animatedElements.forEach(el => observer.observe(el));
});